import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_FI.json';
import exercises from './FITNESS_EXERCISES_FI.json';
import recipes from './FITNESS_RECIPES_FI.json';

export const FITNESS_DATA_FI: ServiceData = {
  articles,
  exercises,
  recipes,
};
